<template>

  <div>
    <b-card
      v-for="opt in mainOptions"
      :key="opt.id"
      :title="opt.label"
      :sub-title="opt.sublabel"
      :sub-title-text-variant="opt.sublabel_color"
      class="mb-n1"
    >
      <b-row>
        <b-form-checkbox
          v-for="sel in opt.data"
          :key="sel.id != null ? sel.id : sel.row"
          v-model="comp.complainMainType"
          :value="sel.id != null ? sel.id : sel.row"
          class="col-3 col-md-4"
          :disabled="disabledCheck"
        >
          {{ sel.name }}
        </b-form-checkbox>
      </b-row>
    </b-card>
    <b-card
      v-for="opt in subOptions"
      :key="opt.id"
      :title="opt.label"
      :sub-title="opt.sublabel"
      :sub-title-text-variant="opt.sublabel_color"
      class="mb-n1"
    >
      <b-row>
        <b-form-checkbox
          v-for="sel in opt.data"
          :key="sel.id != null ? sel.id : sel.row"
          v-model="comp.complainSubType"
          :value="sel.id != null ? sel.id : sel.row"
          class="col-3 col-md-4"
          :disabled="disabledCheck"
        >
          {{ sel.name }}
        </b-form-checkbox>
      </b-row>
    </b-card>
    <b-card
      v-for="opt in causeOptions"
      :key="opt.id"
      :title="opt.label"
      :sub-title="opt.sublabel"
      :sub-title-text-variant="opt.sublabel_color"
      class="mb-n1"
    >
      <b-row>
        <b-form-checkbox
          v-for="sel in opt.data"
          :key="sel.id != null ? sel.id : sel.row"
          v-model="comp.complainCause"
          :value="sel.id != null ? sel.id : sel.row"
          class="col-3 col-md-4"
          :disabled="disabledCheck"
        >
          {{ sel.name }}
        </b-form-checkbox>
      </b-row>
    </b-card>
    <b-card
      v-for="opt in placeOptions"
      :key="opt.id"
      :title="opt.label"
      :sub-title="opt.sublabel"
      :sub-title-text-variant="opt.sublabel_color"
      class="mb-n1"
    >
      <b-row>
        <b-form-checkbox
          v-for="sel in opt.data"
          :key="sel.id != null ? sel.id : sel.row"
          v-model="comp.complainPlace"
          :value="sel.id != null ? sel.id : sel.row"
          class="col-3 col-md-4"
          :disabled="disabledCheck"
        >
          {{ sel.name }}
        </b-form-checkbox>
      </b-row>
    </b-card>
    <b-card
      v-for="opt in motivateOptions"
      :key="opt.id"
      :title="opt.label"
      :sub-title="opt.sublabel"
      :sub-title-text-variant="opt.sublabel_color"
      class="mb-n1"
    >
      <b-row>
        <b-form-checkbox
          v-for="sel in opt.data"
          :key="sel.id != null ? sel.id : sel.row"
          v-model="comp.complainMotive"
          :value="sel.id != null ? sel.id : sel.row"
          class="col-3 col-md-4"
          :disabled="disabledCheck"
        >
          {{ sel.name }}
        </b-form-checkbox>
      </b-row>
    </b-card>
    <b-card
      v-for="opt in paymentOptions"
      :key="opt.id"
      :title="opt.label"
      :sub-title="opt.sublabel"
      :sub-title-text-variant="opt.sublabel_color"
      class="mb-n1"
    >
      <b-row>
        <b-form-checkbox
          v-for="sel in opt.data"
          :key="sel.id != null ? sel.id : sel.row"
          v-model="comp.complainPayment"
          :value="sel.id != null ? sel.id : sel.row"
          class="col-3 col-md-4"
          :disabled="disabledCheck"
        >
          {{ sel.name }}
        </b-form-checkbox>
      </b-row>
    </b-card>
  </div>

</template>

<script>
import {
  BRow, BCol, BTabs, BTab, BButton, BCard, BCardText, BCardHeader, BCardBody, BFormCheckboxGroup, BFormCheckbox,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormCheckbox,
    BFormCheckboxGroup,
  },
  props: {
    complain: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    console.log('props.complain')
    console.log(props.complain)
    console.log('props.complain')
    return {
      comp: props.complain[0],
      disabledCheck: props.disabled,
    }
  },
  data() {
    return {
      mainOptions: [],
      subOptions: [],
      causeOptions: [],
      placeOptions: [],
      motivateOptions: [],
      paymentOptions: [],
    }
  },
  created() {
    this.$http.get('/complain-checklist/main')
      .then(res => { this.mainOptions = res.data })
    this.$http.get('/complain-checklist/sub')
      .then(res => {
        res.data[0].data = res.data[0].data.slice(0, 7)
        this.subOptions = res.data
      })
    this.$http.get('/complain-checklist/cause')
      .then(res => {
        res.data[0].data = res.data[0].data.slice(0, 6)
        this.causeOptions = res.data
      })
    this.$http.get('/complain-checklist/place')
      .then(res => { this.placeOptions = res.data })
    this.$http.get('/complain-checklist/motivate')
      .then(res => { this.motivateOptions = res.data })
    this.$http.get('/complain-checklist/payment')
      .then(res => { this.paymentOptions = res.data })
  },
}
</script>

<style>

</style>
